import { isStandalone } from "@/utils/pwa";
import { useDevicePlatform } from "@/composables/useDevicePlatform";
import { computed } from "vue";

/**
 * Whether or not to show "Install" buttons for the PWA.
 */
export function useShowInstallButton() {
	const { isMobile } = useDevicePlatform();

	return computed(() => !isStandalone() && isMobile.value);
}
